<template>
  <div class="wrapper">
    <div class="body">
      <div class="row">
        <div class="col-md-6 pt-3 pl-4 pr-4">
          <h4 class="m-0 p-0">{{ $t('callcenter.pageTitle') }}</h4>
          <p class="text-muted m-0">{{ $t('callcenter.pageSubTitle') }}</p>
          <hr />
          <p class="text-black-50 m-0 p-0">
            {{ $t('callcenter.pageRuleText') }}
            <strong v-if="resToken"> {{ resToken.rule }}</strong>
          </p>
        </div>
        <div class="col-md-6">
          <b-alert :show="schedulingDate" class="pull-right" variant="warning"><i class="fa circle-exclamation"></i> Agendado para: {{ formatDate(schedulingDate) }}</b-alert>
        </div>
      </div>
    </div>

    <div
      v-if="notInvite"
      class="body-content mt-3"
      style="background: #ffffff;"
    >
      <div
        class="row"
        style="
          padding-top: 8%;
          max-width: 1200px;
          margin-left: auto;
          margin-right: auto;
        "
      >
        <div class="col-md-6">
          <h4>Você não possui nenhum cliente para pesquisa na regra atual.</h4>
          <br />
          <!-- <p v-if="nextInviteDate">
            Próximo agendamento: {{ formatDate(nextSchedulingDate) }}
          </p> -->
          <br />
        </div>

        <div class="col-md-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            width="80%"
            viewBox="0 0 601.6 630"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <rect
              x="756.96373"
              y="195.50659"
              width="1.67162"
              height="109.19622"
              transform="translate(-245.06837 491.48745) rotate(-46.40674)"
              fill="#e6e6e6"
            />
            <polygon
              points="498.845 143.982 497.175 144.083 497.679 152.309 489.437 152.21 489.419 153.882 499.457 154.001 498.845 143.982"
              fill="#e6e6e6"
            />
            <polygon
              points="427.781 76.326 427.763 77.998 419.522 77.899 420.026 86.125 418.355 86.226 417.745 76.206 427.781 76.326"
              fill="#e6e6e6"
            />
            <circle cx="458.59956" cy="115.10464" r="9.19286" fill="#e6e6e6" />
            <rect
              x="389.27378"
              y="249.26889"
              width="109.19622"
              height="1.67162"
              transform="translate(-349.25942 240.03057) rotate(-43.59326)"
              fill="#e6e6e6"
            />
            <polygon
              points="103.815 154.001 113.853 153.882 113.834 152.21 105.593 152.309 106.097 144.083 104.427 143.982 103.815 154.001"
              fill="#e6e6e6"
            />
            <polygon
              points="185.527 76.206 184.916 86.226 183.246 86.125 183.749 77.899 175.508 77.998 175.49 76.326 185.527 76.206"
              fill="#e6e6e6"
            />
            <circle cx="144.67187" cy="115.10464" r="9.19286" fill="#e6e6e6" />
            <path
              d="M669.36429,325.54286H530.63571a7.53,7.53,0,0,1-7.52142-7.52143v-175.5A7.53,7.53,0,0,1,530.63571,135H669.36429a7.53,7.53,0,0,1,7.52142,7.52143v175.5A7.53,7.53,0,0,1,669.36429,325.54286ZM530.63571,136.67143a5.85658,5.85658,0,0,0-5.85,5.85v175.5a5.85658,5.85658,0,0,0,5.85,5.85H669.36429a5.85658,5.85658,0,0,0,5.85-5.85v-175.5a5.85658,5.85658,0,0,0-5.85-5.85Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
            <path
              d="M588.45985,219.35842h-30.537a3.76488,3.76488,0,0,1-3.76071-3.76071V179.562a3.76488,3.76488,0,0,1,3.76071-3.76071h30.537a3.76489,3.76489,0,0,1,3.76072,3.76071v36.03569A3.76489,3.76489,0,0,1,588.45985,219.35842Z"
              transform="translate(-299.2 -135)"
              fill="#4de594"
            />
            <path
              d="M647.79557,236.07271h-30.537a3.7649,3.7649,0,0,1-3.76072-3.76071V196.27631a3.7649,3.7649,0,0,1,3.76072-3.76072h30.537a3.76489,3.76489,0,0,1,3.76071,3.76072V232.312A3.76489,3.76489,0,0,1,647.79557,236.07271Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M600.15985,287.05128h-30.537a3.76488,3.76488,0,0,1-3.76071-3.76071V247.25488a3.76489,3.76489,0,0,1,3.76071-3.76072h30.537a3.7649,3.7649,0,0,1,3.76072,3.76072v36.03569A3.76489,3.76489,0,0,1,600.15985,287.05128Z"
              transform="translate(-299.2 -135)"
              fill="#ff6584"
            />
            <path
              d="M893.27857,506H754.55a7.53005,7.53005,0,0,1-7.52143-7.52143v-175.5a7.53005,7.53005,0,0,1,7.52143-7.52143H893.27857A7.53,7.53,0,0,1,900.8,322.97857v175.5A7.53,7.53,0,0,1,893.27857,506ZM754.55,317.12857a5.85658,5.85658,0,0,0-5.85,5.85v175.5a5.85658,5.85658,0,0,0,5.85,5.85H893.27857a5.85658,5.85658,0,0,0,5.85-5.85v-175.5a5.85658,5.85658,0,0,0-5.85-5.85Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
            <path
              d="M847.73214,354.31786H800.09643a3.34286,3.34286,0,0,1,0-6.68572h47.63571a3.34286,3.34286,0,0,1,0,6.68572Z"
              transform="translate(-299.2 -135)"
              fill="#4de594"
            />
            <path
              d="M871.13214,386.075H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M871.13214,403.625H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M871.13214,421.175H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M871.13214,438.725H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M871.13214,456.275H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M871.13214,473.825H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M445.45,506H306.72143A7.53,7.53,0,0,1,299.2,498.47857v-175.5a7.53,7.53,0,0,1,7.52143-7.52143H445.45a7.53005,7.53005,0,0,1,7.52143,7.52143v175.5A7.53005,7.53005,0,0,1,445.45,506ZM306.72143,317.12857a5.85658,5.85658,0,0,0-5.85,5.85v175.5a5.85658,5.85658,0,0,0,5.85,5.85H445.45a5.85658,5.85658,0,0,0,5.85-5.85v-175.5a5.85658,5.85658,0,0,0-5.85-5.85Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
            <path
              d="M423.44834,356.89277H381.66263a3.34286,3.34286,0,0,1,0-6.68572h41.78571a3.34286,3.34286,0,1,1,0,6.68572Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
            <path
              d="M423.44834,374.44277H381.66263a3.34286,3.34286,0,0,1,0-6.68572h41.78571a3.34286,3.34286,0,1,1,0,6.68572Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
            <path
              d="M360.22223,384.43578h-30.537a3.76489,3.76489,0,0,1-3.76072-3.76071V344.63938a3.7649,3.7649,0,0,1,3.76072-3.76072h30.537a3.76489,3.76489,0,0,1,3.76071,3.76072v36.03569A3.76488,3.76488,0,0,1,360.22223,384.43578Z"
              transform="translate(-299.2 -135)"
              fill="#4de594"
            />
            <path
              d="M423.1588,410.37848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M423.1588,427.92848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M423.1588,445.47848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M423.1588,463.02848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M423.1588,480.57848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M497.89518,607.71863V571.68294a3.76489,3.76489,0,0,1,3.76071-3.76071h30.537a3.76489,3.76489,0,0,1,3.76071,3.76071v36.03569a3.7649,3.7649,0,0,1-3.76071,3.76072h-30.537A3.7649,3.7649,0,0,1,497.89518,607.71863Z"
              transform="translate(-299.2 -135)"
              fill="#e6e6e6"
            />
            <path
              d="M508.89518,595.71863V559.68294a3.76489,3.76489,0,0,1,3.76071-3.76071h30.537a3.76489,3.76489,0,0,1,3.76071,3.76071v36.03569a3.7649,3.7649,0,0,1-3.76071,3.76072h-30.537A3.7649,3.7649,0,0,1,508.89518,595.71863Z"
              transform="translate(-299.2 -135)"
              fill="#4de594"
            />
            <path
              d="M645.78429,584.18843a9.07776,9.07776,0,0,1-2.39821-13.71145l-9.4656-69.18787,19.71756.9678,3.09564,67.48557a9.12692,9.12692,0,0,1-10.94939,14.446Z"
              transform="translate(-299.2 -135)"
              fill="#a0616a"
            />
            <path
              d="M656.34418,503.17871a3.70494,3.70494,0,0,1-1.5051,1.06441l-17.71963,6.76294a3.72283,3.72283,0,0,1-4.729-1.96465l-15.69629-35.27523a14.73962,14.73962,0,0,1-.7212-10.43132,14.33679,14.33679,0,0,1,10.91159-9.78216,13.67275,13.67275,0,0,1,5.89.08316,14.27981,14.27981,0,0,1,10.26305,8.92147l13.956,36.89A3.73032,3.73032,0,0,1,656.34418,503.17871Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <polygon
              points="264.807 618.06 252.547 618.06 248.102 570.549 264.809 570.773 264.807 618.06"
              fill="#a0616a"
            />
            <path
              d="M243.79024,614.55666h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H228.90338a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,243.79024,614.55666Z"
              fill="#2f2e41"
            />
            <polygon
              points="321.807 618.06 309.547 618.06 303.715 570.772 321.809 570.773 321.807 618.06"
              fill="#a0616a"
            />
            <path
              d="M300.79024,614.55666h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H285.90338a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,300.79024,614.55666Z"
              fill="#2f2e41"
            />
            <path
              d="M622.54889,736.23552l-19.25513-1.42578a4.50578,4.50578,0,0,1-4.16235-4.27051L594.838,641.80876a3.50008,3.50008,0,0,0-6.92481-.5332L570.002,728.68278a4.50575,4.50575,0,0,1-4.76709,3.582l-17.40576-1.39257a4.4995,4.4995,0,0,1-4.1189-4.93262L559.858,564.46306a4.49952,4.49952,0,0,1,5.43359-3.94922l61.406,13.34863a4.511,4.511,0,0,1,3.543,4.48145L627.38067,731.8322a4.5022,4.5022,0,0,1-4.489,4.416C622.77789,736.24821,622.66363,736.24333,622.54889,736.23552Z"
              transform="translate(-299.2 -135)"
              fill="#2f2e41"
            />
            <circle cx="306.50339" cy="269.88758" r="24.56103" fill="#a0616a" />
            <path
              d="M567.59552,576.9152a21.96161,21.96161,0,0,1-7.2937-16.86621c0-35.30078,30.55566-114.168,31.51367-116.6289.0935-.59278.89966-.84864,5.12939-3.70606,4.23242-2.85937,10.335-3.29883,18.13941-1.30566a4.47911,4.47911,0,0,1,3.25,3.31836l1.4519,2.09765a3.49144,3.49144,0,0,0,2.02881,2.40625c6.29346,2.65137,26.29809,14.87793,19.48144,60.89161-6.33227,42.74316-8.90185,67.88086-9.71264,76.70507a4.49122,4.49122,0,0,1-4.07154,4.06543c-3.08569.27637-8.38183.64356-14.68945.64356C598.20172,588.5363,578.14654,586.56364,567.59552,576.9152Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M538.24736,563.83729a9.07771,9.07771,0,0,1,5.649-12.72182L574.58944,488.39l15.83345,11.79069-35.034,57.76251a9.12692,9.12692,0,0,1-17.14158,5.89414Z"
              transform="translate(-299.2 -135)"
              fill="#a0616a"
            />
            <path
              d="M592.15633,502.454a3.7049,3.7049,0,0,1-1.8429.04517l-18.48219-4.25807a3.72282,3.72282,0,0,1-2.832-4.26646l6.62251-38.03759a14.73969,14.73969,0,0,1,5.21371-9.06366,14.33681,14.33681,0,0,1,14.51142-2.04255,13.67258,13.67258,0,0,1,4.84448,3.35107,14.27983,14.27983,0,0,1,3.55082,13.12686l-8.96734,38.40871A3.7303,3.7303,0,0,1,592.15633,502.454Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M599.95291,427.0789a10.58407,10.58407,0,0,1-2.83917-9.3866c.85636-4.47943,1.35942-7.41039,1.45471-8.47667h0c.32608-3.64766-3.36133-6.60057-7.01009-7.07047-.1414-.01845-.25976-.03074-.35857-.03865.09288.09135.19279.18445.2804.267.693.65084,1.55573,1.46153,1.35064,2.29769-.12362.50327-.58364.86075-1.40663,1.09087-5.70622,1.59678-10.1009.13087-13.83068-4.61645a11.026,11.026,0,0,1-2.10511-4.598c-1.33593-6.5549,2.2239-12.14277,5.4458-15.67537,2.6567-2.91295,6.96354-6.44907,12.39419-6.75209,4.2234-.23583,9.24563,2.19448,10.74888,6.57423a8.15937,8.15937,0,0,1,6.36123-3.58618,14.662,14.662,0,0,1,8.15827,2.26914c11.90914,6.8219,17.02732,23.07258,11.17684,35.48763-3.68038,7.80914-11.65421,13.62273-20.80981,15.17209a10.39312,10.39312,0,0,1-1.7349.14668A10.11515,10.11515,0,0,1,599.95291,427.0789Z"
              transform="translate(-299.2 -135)"
              fill="#2f2e41"
            />
            <path
              d="M484.77874,765h195a1,1,0,0,0,0-2h-195a1,1,0,1,0,0,2Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
          </svg>
        </div>
      </div>
    </div>

    <div class="body-content mt-3" v-if="!notInvite">
      <div class="header">
        <div class="pt-3 pb-1 pl-4 pr-4">
          <h6>Call center</h6>
        </div>
      </div>

      <div class="content">
        <div class="row">
          <div class="col-4" style="padding-right: 0;">
            <b-card style="padding-right: 0; height: 590px; overflow-y: auto;">
              <div class="pt-2">
                <b-button class="btn" style="
                    width: 32%;
                    border-radius: 0;
                    border: none;
                    background: transparent;
                  " @click="viewType = 'info'" :style="{
                    borderBottom:
                      viewType === 'info' ? '2px solid #4DE594' : 'none',
                    color: viewType === 'info' ? '#4DE594' : '',
                  }">Informações</b-button>

                <b-button class="btn" style="
                    width: 33%;
                    border-radius: 0;
                    border: none;
                    background: transparent;
                  " @click="viewType = 'indicators'" :style="{
                    borderBottom:
                      viewType === 'indicators' ? '2px solid #4DE594' : 'none',
                    color: viewType === 'indicators' ? '#4DE594' : '',
                  }">Indicadores</b-button>

                <b-button class="btn" style="
                    width: 32%;
                    border-radius: 0;
                    border: none;
                    background: transparent;
                  " @click="viewType = 'history'" :style="{
                    borderBottom:
                      viewType === 'history' ? '2px solid #4DE594' : 'none',
                    color: viewType === 'history' ? '#4DE594' : '',
                  }">Histórico</b-button>

                <div style="
                    width: 100%;
                    height: 1px;
                    border-bottom: solid 2px #e8e8e8;
                    margin-top: -2px;
                  "></div>
              </div>

              <div class="p-4" v-if="viewType === 'info'">
                <div class="card-content mb-3">
                  <p>
                    Nome:
                    <span class="pull-right">{{ researchInfo.name }}</span>
                  </p>
                  <p>
                    {{ $t('answers.answersDetails.email') }}:<span class="pull-right"> {{ researchInfo.email }} </span>
                  </p>
                  <p>
                    {{ $t('answers.answersDetails.phone') }}:<span class="pull-right"> {{ researchInfo.phone }} </span>
                  </p>
                  <p>ControlID:<span class="pull-right"> {{ researchInfo.controlId }} </span></p>
                </div>

                <div class="mt-3 mb-1">
                  <label>
                    <h6>Selecione o telefone abaixo para discar</h6>
                  </label>
                </div>

                <div class="form-group form-inline">
                  <div class="col-10" style="padding-left: 0; padding-right: 0; margin-right: 0;">
                    <b-form-select style="width: 100%" v-model="researchInfo.phone">
                      <b-form-select-option :value="researchInfo.phone">{{ researchInfo.phone }}
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                  <div class="col-2 text-right" style="padding-right: 0">
                    <b-button variant="outline-primary" block v-b-modal="'modal-contact-info'">
                      <font-awesome-icon :icon="['fas', 'pen']" />
                    </b-button>
                  </div>
                </div>

                <b-button class="mt-3 mb-3" block @click="handleCall" :variant="statusCall === 'calling' ? 'danger' : 'primary' ">
                  {{ statusCall === 'calling' ? 'Clique para encerrar' : 'Clique para ligar'  }}
                </b-button>

                <div class="mt-3 mb-1">
                  <label>
                    <h6>Status da ligação</h6>
                  </label>
                </div>
                <b-form-select style="width: 100%" :options="statusOptions" v-model="selectedStatus">
                  <!-- <b-form-select-option v-for="(option, i) in [0, 1, 2]" :key="i" :value="option">{{ option }}
                  </b-form-select-option> -->
                </b-form-select>

                <div v-show="selectedStatus === 5">
                  <div class="row mt-3">
                    <div class="col-6">
                      <label>
                        <h6>Data da próxima tentativa:</h6>
                      </label>
                      <b-input type="date" v-model="schedulingDate"></b-input>
                    </div>
                    <div class="col-6">
                      <label>
                        <h6>Horário da próxima tentativa:</h6>
                      </label>
                      <b-input type="time" v-model="schedulingTime"></b-input>
                    </div>
                  </div>

                  <div class="custom-switch mt-3">
                    <div class="">
                      <input type="checkbox" class="custom-control-input" id="switch-exclusive" v-model="schedulingExclusive" />
                      <label class="custom-control-label" for="switch-exclusive">Agendamento exclusivo</label>
                    </div>
                  </div>
                </div>

                <b-button class="mt-3 mb-3" block :disabled="!selectedStatus" @click="updateStatus">Salvar status</b-button>

                <div class="footer">
                  <div class="mt-3 mb-1">
                    <label>
                      <h6>Enviar pesquisa para:</h6>
                    </label>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <b-button v-b-modal="'modal-email'" variant="outline-info" block>Email</b-button>
                    </div>
                    <div class="col-4" style="padding-right: 0; padding-left: 0;">
                      <b-button v-b-modal="'modal-wpp'" variant="outline-info" block>Whatsapp</b-button>
                    </div>
                    <div class="col-4">
                      <b-button v-b-modal="'modal-sms'" variant="outline-info" block>SMS</b-button>
                    </div>

                  </div>
                </div>
              </div>
              <!-- /info -->
              <div v-if="viewType === 'indicators'">
                <div class="row p-4">
                  <b-badge class="ml-2 mr-2 mb-3" variant="light" v-for="(item, i) of researchInfo.indicators" :key="i">{{ item.column }}: {{item.value}}
                  </b-badge>
                </div>
              </div>

              <!-- /info -->
              <div v-if="viewType === 'history'">
                <div v-if="timeline" class="time-line">

                  <div
                class="vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
              >
                <div
                  class="vertical-timeline-item vertical-timeline-element"
                  v-for="(item, i) in timeline"
                  :key="i"
                >
                  <div class="mb-4">
                    <span class="vertical-timeline-element-icon bounce-in">
                      <i class="badge badge-dot badge-dot-xl">
                        <i
                          style="color: #4de594; font-size: 20px;"
                          class="fab fa-whatsapp"
                        ></i>
                      </i>
                    </span>
                    <div class="vertical-timeline-element-content bounce-in">
                      <p class="timeline-">
                        <strong>Chamada realizada</strong>
                      </p>

                      <p class="timeline-textarea">
                        <strong>Agente: </strong> {{ item.responsible }}
                      </p>
                      <p class="mb-0">
                        <strong>Status: </strong> <label v-if="item.status">{{ item.status }}</label>
                      </p>
 
                      <span class="vertical-timeline-element-date">
                        <strong>Data: </strong>{{ formatDate(item.date) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
                </div>
              </div>

            </b-card>
          </div>

          <div class="col-8">
            <b-card id="scroll-div" style=" height: 590px; overflow-y: scroll;">
              <div class="pt-3 pl-4 pr-4 pb-1">
                <strong>Pesquisa com base na ação: </strong> {{ researchInfo.action.name }}

                <div class="custom-switch pull-right">
                  <div class="">
                    <input type="checkbox" class="custom-control-input" id="switch-enable-search" v-model="enable" />
                    <label class="custom-control-label" for="switch-enable-search">Habilitar pesquisa</label>
                  </div>
                </div>
              </div>
              <div style="
                  width: 100%;
                  height: 1px;
                  border-bottom: solid 2px #e8e8e8;
                "></div>

              <div class="p-4" v-if="!loading">
                <Research v-if="resToken" :enable="enable" :token="resToken.researchToken"></Research>
              </div>
            </b-card>
          </div>

        </div>
        <div class="row">
          <div class="col-12 text-right pt-2 pr-3">
            <b-button class="pull-right" @click="nextInvite">Próximo</b-button>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-contact-info"
      title="Dados do contato"
      cancel-title="Cancelar"
      ok-title="Salvar"
      size="md"
      centered
      @ok="updateContactInfo"
    >

      <b-row class="mt-2">
          <b-col sm="12">
            <label>Alterar dados do convite</label>
          </b-col>
        </b-row>  

      <b-row class="mt-2">
        <b-col sm="2">
          <label for="input-name">Nome</label>
        </b-col>
        <b-col sm="10">
          <b-form-input v-model="contactInfo.name" id="input-name" size="sm" placeholder="Nome Sobrenome"></b-form-input>
        </b-col>
      </b-row>
      
      <b-row class="mt-2">
        <b-col sm="2">
          <label for="input-email">Email</label>
        </b-col>
        <b-col sm="10">
          <b-form-input v-model="contactInfo.email" id="input-email" size="sm" placeholder="Email"></b-form-input>
        </b-col>
      </b-row>
      
      <b-row class="mt-2 mb-4">
        <b-col sm="2">
          <label for="input-phone">Telefone</label>
        </b-col>
        <b-col sm="10">
          <b-form-input v-model="contactInfo.phone" id="input-phone" size="sm" placeholder="Telefone"></b-form-input>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-email"
      title="Confirmar dados de contato"
      cancel-title="Cancelar"
      ok-title="enviar"
      size="md"
      centered
      @ok="sendResearchByEmail"
    >
      
      <b-row class="mt-2">
        <b-col sm="2">
          <label for="input-email">Email</label>
        </b-col>
        <b-col sm="10">
          <b-form-input v-model="contactInfo.email" id="input-email" size="sm" placeholder="Email"></b-form-input>
        </b-col>
      </b-row>
      
    </b-modal>

    <b-modal
      id="modal-sms"
      title="Confirmar dados de contato"
      cancel-title="Cancelar"
      ok-title="enviar"
      size="md"
      centered
      @ok="sendResearchBySMS"
    >
      
      <b-row class="mt-2">
        <b-col sm="2">
          <label for="input-sms">Telefone</label>
        </b-col>
        <b-col sm="10">
          <b-form-input v-model="contactInfo.phone" id="input-sms" size="sm" placeholder="Telefone"></b-form-input>
        </b-col>
      </b-row>
      
    </b-modal>

    <b-modal
      id="modal-wpp"
      title="Enviar link de pesquisa automatizada via WhatsApp"
      cancel-title="Cancelar"
      ok-title="enviar"
      size="lg"
      centered
      @ok="sendWhatsappWeb"
    >
      
    <div class="m-2">
      <p><strong>Nome: </strong> {{ contactInfo.name }}</p>
      <p><strong>Telefone: </strong> {{ contactInfo.phone }}</p>
      <p><strong>Ação: </strong> {{ researchInfo.action.name }}</p>
      <p><strong>Mensagem: </strong></p>

      <b-form-textarea
      id="textarea"
      v-model="wppMessage"
      rows="10"
      max-rows="10"
      columns="80"
    ></b-form-textarea>

    </div>
      
    </b-modal>
  </div>
</template>
  
<script>
import { mapState, mapActions } from 'vuex';
import swal from 'sweetalert';
import * as moment from 'moment';
import api from '../../../services/api';
import Research from './research.vue';
import EventBus from '../../../eventBus';

const normalize = require('normalize-strings');

export default {
  name: 'CallCenter',
  components: {
    Research,
  },
  data: () => ({
    contactInfo: {
      name: null,
      email: null,
      phone: null
    },
    notInvite: false,
    userAuth: null,
    viewType: 'info',
    currentRule: null,
    selectedStatus: null,
    schedulingDate: null,
    schedulingTime: null,
    schedulingExclusive: false,
    statusSaved: false,
    statusCall: null,
    callId: null,
    timeline: null,
    wppMessage: '',
    enable: false,
    researchInfo: {
      reply: {},
      additionalQuestions: [],
      action: {name: null},
    },
    resToken: null,
    apiRoot: null,
    apiServerless: null,
    statusOptions: [
      {text: 'Pesquisado com sucesso', value: 1},
      {text: 'Retornar para cliente', value: 5},
      {text: 'Não atende', value: 6},
      {text: 'Ocupado', value: 7},
      {text: 'Impossível completar a chamada', value: 8},
      {text: 'Não interessado', value: 9},
      {text: 'Número pertence a outra pessoa', value: 10},
      {text: 'Regra de negócio/Não se aplica', value: 11},
      {text: 'Pesquisa enviada por email', value: 2},
      {text: 'Pesquisa enviada por Whatsapp', value: 3},
      {text: 'Pesquisa enviada por SMS', value: 4},
      {text: 'Black list', value: 12},
    ]
  }),
  methods: {
    ...mapActions('research', ['getInfo', 'setAnswer']),
    ...mapActions('actions', ['setTestNpsReview']),
    formatDate(date) {
      return moment(date).add(3, 'hours').format('DD/MM/YYYY HH:mm');
    },
    async handleCall(){
      if(this.statusCall === 'calling'){
        this.endCall();
      } else {
        this.startCall();
      }
    },
    async startCall(){
      api.get(`/call-center/start-call/${this.researchInfo.controlId}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          }).then(( res )=>{
            
            this.statusCall = 'calling'
            this.callId = res.data.callId;

          }).catch((err)=>{
            this.statusCall = null
            window.console.log(err)
          });
    },
    async endCall(){
      if(this.statusCall === 'calling'){
        api.post('/call-center/end-call', {
          callId: this.callId
        },
        {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          }).then(( res )=>{

            this.statusCall = null

          }).catch((err)=>{
            window.console.log(err)
          });
      }
    },
    async sendWhatsappWeb() {
      const msg = this.wppMessage;
      const target = `https://api.whatsapp.com/send?phone=${encodeURIComponent(
        this.contactInfo.phone,
      )}&text=${encodeURIComponent(msg)}`;
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = target;
      a.click();
      a.remove();
    },
    async buildWppWebMsg() {
      let msg;
      let myName;
      let item = null;
      let temp = null;
        item = this.researchInfo;
        msg = item.action.email.template.myHTML;
        msg = msg.replaceAll('<br />', String.fromCharCode(13));
        myName = item.name ? item.name : '';

        if (myName) {
          myName = myName.split(' ')[0];
          myName =
            myName.substring(0, 1).toUpperCase() +
            myName.substring(1).toLowerCase();
          item.name = myName;
        }
        if (
          msg.indexOf('&lt;pnome&gt;') === -1 &&
          msg.indexOf('&lt;nome&gt;') === -1 &&
          myName
        ) {
          msg = `${myName},${String.fromCharCode(13)}${msg}`;
        }
        msg += String.fromCharCode(13);
        msg += String.fromCharCode(13);
        msg += 'Acesse a nossa pesquisa através do link';
        msg += String.fromCharCode(13);
        msg += `${item.shortUrl}-W`;
        msg = this.replaceTagsOnText({
          name: item.name,
          text: msg,
          indicators: item.indicators,
        });
        temp = document.createElement('div');
        temp.innerHTML = msg;
        this.wppMessage =
          temp.textContent || temp.innerText || '';
        temp.remove();
    },
    normalizeText(text) {
      if (text) {
        const regexSpace = new RegExp(' ', 'gi');
        const convertedText = text.toString();
        const normalizedText = normalize(convertedText)
          .trim()
          .toLowerCase()
          .replace(/ +(?= )/g, '')
          .replace(regexSpace, '_');
        return normalizedText;
      }
      return '';
    },
    replaceTagsOnText({ name, text, indicators }) {
      let replacedText = text;
      const arrayOfTags = [];
      arrayOfTags.push(
        { key: 'nome', value: name },
        { key: 'pnome', value: name ? name.split(' ')[0] : '' },
      );
      if (indicators) {
        indicators.forEach((indicator) => {
          arrayOfTags.push({
            key: this.normalizeText(indicator.column),
            value: indicator.value,
          });
        });
      }
      arrayOfTags.forEach((tag) => {
        const regexForHTML = new RegExp(`&lt;${tag.key}&gt;`, 'gi');
        if (replacedText) {
          replacedText = replacedText.replace(
            regexForHTML,
            tag.value ? tag.value : '',
          );
        }
      });
      return replacedText;
    },
    async updateStatus(){
      if(this.selectedStatus){
        if(this.selectedStatus === 5){
          if(this.schedulingDate && this.schedulingTime){
            const diff = moment(moment(), 'DD/MM/YYYY HH:mm').diff(
              moment(
                moment(`${this.schedulingDate} ${this.schedulingTime}`),
                'DD/MM/YYYY HH:mm',
              ),
            );
            
            if(diff < 0){
              this.saveStatus();
            } else {
              swal({
                title: 'Ops!',
                text: 'A data do agendamento precisa ser uma data futura.',
                icon: 'warning',
            });
            }
          } else {
            swal({
              title: 'Ops!',
              text: 'Por favor escolha uma data e hora para o agendamento!',
              icon: 'warning',
            });
          }
        } else {
         this.saveStatus();
        }
    }
    },
    async saveStatus(){
      api.patch(`call-center/update-invite-status/${this.researchInfo.controlId}`, {
            callStatus: this.selectedStatus,
            date: this.selectedStatus === 5 && this.schedulingDate ? this.schedulingDate : null,
            time: this.selectedStatus === 5 && this.schedulingTime ? this.schedulingTime : null,
            exclusive: this.schedulingExclusive ? this.schedulingExclusive : false,
            callId: this.callId,
          }, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          }).then(()=>{
            this.statusSaved = true;
            this.getTimeline();
            swal({
              title: 'Status atualizado!',
              icon: 'success',
            });
          }).catch((err)=>{
            window.console.log(err)
          });
    },
    async getCompanyConsumption() {
      const response = await api.get(`consumption/${this.userAuth.companyId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });
      return response.data.consumption;
    },
    async sendResearchByEmail(){

      if(this.contactInfo.email){
        api.put(
          `/callcenter-update-invite/${this.researchInfo.controlId}`,
          {
            email: this.contactInfo.email
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        const consumptions = await this.getCompanyConsumption();
        let exceededQuotaEmail = false;
        let balanceMsg = 0;
        const totalInvites = 1;

        let balanceEmail = consumptions.plan.qtyEmail - consumptions.totalEmail;
        if (balanceEmail < 0) {
          balanceEmail = 0;
        }
        if (totalInvites > balanceEmail) {
          exceededQuotaEmail = true;
        }

        if (exceededQuotaEmail) {
          balanceMsg = balanceEmail;
        }

        if (exceededQuotaEmail){
        swal({
          title: this.$t('newAction.stepThree.messages.exceeded.title'),
          text: this.$t('newAction.stepThree.messages.exceeded.description', {
            totalInvites: `${totalInvites}`,
            balanceMsg: `${balanceMsg}`,
          }),
          icon: 'error',
          dangerMode: true,
        });
        
      } else {
        api.post(
          '/call-center/send-invite',
            {
              inviteId: this.resToken.inviteId,
              sendBy: 'email',
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
        ).then(()=>{
          swal({
            title: `A pesquisa foi enviada!`,
            icon: 'success',
          });
        }).catch((err)=>{
          window.console.log(err)
          swal({
            title: `Ops!`,
            text: 'Não foi possível enviar a pesquisa.',
            icon: 'success',
          });
        });

      }


      }
      
    },
    async sendResearchBySMS(){

      if(this.contactInfo.phone){
        api.put(
          `/callcenter-update-invite/${this.researchInfo.controlId}`,
          {
            phone: this.contactInfo.phone
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        const consumptions = await this.getCompanyConsumption();
        let exceededQuotaSms = false;
        let balanceMsg = 0;
        const totalInvites = 1;

        let balanceSms = consumptions.plan.qtySms - consumptions.totalSms;
        if (balanceSms < 0) {
          balanceSms = 0;
        }
        if (totalInvites > balanceSms) {
          exceededQuotaSms = true;
        }

        if (exceededQuotaSms) {
          balanceMsg = balanceSms;
        }

        if (exceededQuotaSms){
        swal({
          title: this.$t('newAction.stepThree.messages.exceeded.title'),
          text: this.$t('newAction.stepThree.messages.exceeded.description', {
            totalInvites: `${totalInvites}`,
            balanceMsg: `${balanceMsg}`,
          }),
          icon: 'error',
          dangerMode: true,
        });
        
      } else {
        api.post(
          '/call-center/send-invite',
            {
              companyId: this.userAuth.companyId,
              inviteId: this.resToken.inviteId,
              sendBy: 'sms',
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
        ).then(()=>{
          swal({
            title: `A pesquisa foi enviada!`,
            icon: 'success',
          });
        }).catch((err)=>{
          window.console.log(err)
          swal({
            title: `Ops!`,
            text: 'Não foi possível enviar a pesquisa.',
            icon: 'success',
          });
        });

      }


      }

    },
    async updateContactInfo(){
      if(!this.contactInfo.name && !this.contactInfo.email && !this.contactInfo.phone) 
        return
      
      let obj = {};
      if(this.contactInfo.name){
        obj = {
          ...obj,
          name: this.contactInfo.name
        }
      }
      if(this.contactInfo.email){
        obj = {
          ...obj,
          email: this.contactInfo.email
        }
      }
      if(this.contactInfo.phone){
        obj = {
          ...obj,
          phone: this.contactInfo.phone
        }
      }

      api.put(
        `/callcenter-update-invite/${this.researchInfo.controlId}`,
        obj,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      ).then(()=>{
        this.researchInfo.name = obj.name ? obj.name : this.researchInfo.name;
        this.researchInfo.email = obj.email ? obj.email : this.researchInfo.email;
        this.researchInfo.phone = obj.phone ? obj.phone : this.researchInfo.phone;
        swal({
            title: 'Status atualizado!',
            icon: 'success',
          });
      }).catch((err)=>{
        window.console.log(err)
      });

    },
    scrollToTop() {
      const div = document.getElementById('scroll-div');
      div.scrollTop = 0;
    },
    async nextInvite(){

      if(this.statusSaved){
        this.getInvite()
      } else {
        swal({
            title: 'Ação não pode ser realizada!',
            text: 'Para avançar para a próxima pesquisa, altere o status',
            icon: 'warning',
          });
      }
      
    },
    async getInvite(){
      this.statusSaved = false;
      this.selectedStatus = null;
      this.loading = true;

      this.apiRoot = process.env.API_ROOT;
      this.apiServerless = process.env.API_SERVERLESS;

      this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    try {
          
      const resToken = await api.get('/call-center/priority', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });
      console.log('response: ', resToken.data);

      this.resToken = resToken.data;

      if(resToken.data && resToken.data.researchToken){
        const response = await this.getInfo(this.resToken.researchToken);
        this.researchInfo = response;
        
        this.schedulingDate = this.resToken.schedulingDate ? this.resToken.schedulingDate : null
        
        this.contactInfo = {
          name: this.researchInfo.name,
          email: this.researchInfo.email,
          phone: this.researchInfo.phone
        };

        this.wppMessage = this.researchInfo.action.email.template.plainText;
        this.buildWppWebMsg()
        this.getTimeline()

        this.$store.state.actions.action = this.researchInfo.action;
      } else {
        this.notInvite = true
      }

      this.loading = false;
    } catch (error) {
      this.loading = false;
      window.console.log(error.response.data.message);
    }
    },
    async getTimeline(){
      const res = await api.get(`/call-center/get-timeline/${this.resToken.inviteId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      console.log('timeline: ', res);

      if(res.data && res.data.timeline){
        this.timeline = res.data.timeline
      }
    }
  },
  computed: {
    ...mapState('actions', ['testNpsReview']),
  },
  async created() {
    this.getInvite()

    EventBus.$on('scroll-div', () => {
      this.scrollToTop();
    });

  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapper {
  padding: 8px;
}

.page-header {
  h3 {
    font-size: 20px;
    margin: 0;
  }

  p {
    font-size: 18px;
  }
}

.body {
  background-color: $white;
  padding: 16px;
  border-radius: 6px;
}

.card-body {
  padding: 0;
}

.card-content-header {
  height: 60px;
}

.body-content {
  border-radius: 6px;

  .header {
    background-color: $white;
    display: flex;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  .content {
    background-color: #e6e6e6;
    padding: 16px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .card-content {
    p {
      color: #888383;
      font-size: 14px;
      padding: 2px;
      margin: 0;
    }
  }

  .btn:focus {
    outline: none;
    box-shadow: none;
  }

  .btn {
    box-shadow: none !important;
  }
}

.badge-light {
  color: #ffffff;
  background-color: #44444474;
  padding: 8px 15px;
  font-weight: normal;
}

label {
  h6 {
    margin: 0;
    padding: 0;
    font-size: 90%;
  }
}

p {
    font-size: 14px;
    padding: 2px;
    margin: 0;
  }

  .time-line {
  .card-body {
    flex: 1 1 auto;
    padding: 1.25rem;
  }

  .vertical-timeline {
    width: 100%;
    position: relative;
    padding: 1.5rem 0 1rem;
  }

  .vertical-timeline::before {
    content: '';
    position: absolute;
    top: 0;
    left: 27px;
    height: 100%;
    width: 2px;
    background: #e9ecef;
    border-radius: 0.25rem;
  }

  .vertical-timeline-element {
    position: relative;
    margin: 0 0 1rem;
  }

  .vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {
    visibility: visible;
    animation: cd-bounce-1 0.8s;
  }

  .vertical-timeline-element-icon {
    position: absolute;
    top: 0;
    left: 20px;
  }

  .vertical-timeline-element-icon .badge-dot-xl {
    box-shadow: 0 0 0 5px #fff;
  }

  .badge-dot-xl {
    width: 18px;
    height: 18px;
    position: relative;
    margin-left: -5px
  }

  .badge:empty {
    display: none;
  }

  .badge-dot-xl::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 0.25rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -5px 0 0 -5px;
    //background: #fff;
  }

  .vertical-timeline-element-content {
    position: relative;
    margin-left: 60px;
    font-size: 0.8rem;
  }

  .vertical-timeline-element-content .timeline-title {
    font-size: 0.8rem;
    text-transform: uppercase;
    margin: 0 0 0.5rem;
    padding: 2px 0 0;
    font-weight: bold;
  }

  .vertical-timeline-element-content .vertical-timeline-element-date {
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    padding-right: 10px;
    text-align: right;
    color: #adb5bd;
    font-size: 0.7619rem;
    white-space: nowrap;
  }

  .vertical-timeline-element-content:after {
    content: '';
    display: table;
    clear: both;
  }
}
// .footer{
//   position: absolute;
//   bottom: 20px;
//   width: 90%;
// }
</style>
  


// WEBPACK FOOTER //
// src/components/organisms/call-center/index.vue